.footer {
  display: flex;
  flex-direction: column;
  gap: var(--spacingLg);
  padding-top: var(--spacingLg);
}
